'use client';

import FilmCard, { FilmListItem } from '@/components/blocks/FilmCard';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { useEffect, useState } from 'react';

interface PaginatedFilmListProps {
    films: FilmListItem[];
    sorting?: boolean
}

const ITEMS_PER_PAGE = 10;

export const isFilmAvailable = (film: FilmListItem) => {
    const isScreeningsExists = film.screenings ? film.screenings.length > 0 : false;
    const isPartOfShortProgramme =
        film.short_programme &&
        film.short_programme.screenings &&
        film.short_programme.screenings.length > 0;
    const isAddToCartDisabled = !isScreeningsExists && !isPartOfShortProgramme;

    // TODO: Fix
    // return !isAddToCartDisabled;
    return false;
};

const PaginatedFilmList = (props: PaginatedFilmListProps) => {
    const { films, sorting = true } = props;
    const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
    const [ref, isIntersecting] = useIntersectionObserver({
        threshold: 1.0,
    });

    const sortedFilms = sorting ? films
        .sort((a, b) => {
            if (isFilmAvailable(a) && !isFilmAvailable(b)) {
                return -1;
            }
            if (!isFilmAvailable(a) && isFilmAvailable(b)) {
                return 1;
            }
            return 0;
        })
        .sort((a, b) => {
            if (a.title < b.title) {
                return -1;
            }
            if (a.title > b.title) {
                return 1;
            }
            return 0;
        }) : films;

    const loadMoreItems = () => {
        setVisibleCount((prevCount) => prevCount + ITEMS_PER_PAGE);
    };

    useEffect(() => {
        if (isIntersecting) {
            loadMoreItems();
        }
    }, [isIntersecting]);

    return (
        <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 justify-between gap-[60px] pt-10 pb-[240px] max-lg:border-t max-lg:border-white/50">
            {sortedFilms.slice(0, visibleCount).map((props) => (
                <FilmCard key={props.id} {...props} />
            ))}
            <div ref={ref} className="h-1" />
        </div>
    );
};

export default PaginatedFilmList;
